import { useCallback, useContext } from 'react'
import loadable from '@loadable/component'
import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLEStaff } from 'selectors/accountSelectors'
import AbTestsButtonLabel from './AbTestsButtonLabel'

const ExperimentControlPanel = loadable(() => import('components/DevTools/ExperimentControlPanel/ExperimentControlPanel'))

function ExperimentPanelButton() {
  const isStaff = useAppSelector(isLEStaff)
  const showModal = useContext(ModalContext)

  const openPanel = useCallback(() => {
    showModal(<ExperimentControlPanel />)
  }, [showModal])

  if (!isStaff) {
    return null
  }

  return (
    <TextButton kind="secondary" onClick={openPanel}>
      <AbTestsButtonLabel />
    </TextButton>
  )
}

export default ExperimentPanelButton
